import jQuery from 'jquery/dist/jquery';
import * as bootstrap from 'bootstrap'
import Utils from '../../../../utils'
import DefaultController from "../../../defaultController";
import ExportEntity from "../../../export/entity";

export default class TeamsExportList extends DefaultController {
    tableElem: any;
    datatable: any;

    async init() {
        this.entity = "exports";
        this.tableElem = jQuery('.datatables-users-exports')
        this.createTable();
        await super.init();

        setInterval(async () => {
            this.datatable.ajax.reload();
        }, 1000)
    }

    getEntityData(elem: any) {
        return ExportEntity.getEntityData(elem)
    }

    bindListeners() {
    }

    createTable() {
        this.datatable = new DataTable(this.tableElem, {
            initComplete: () => {
                this.tableElem.closest(".card").find(".loading-body").addClass("d-none")
                this.tableElem.closest(".card").find(".card-datatable").removeClass("d-none")
            },
            ajax: `/api/v1/exports`,
            columns: [
                {data: 'uuid'},
                {data: 'uuid'},
                {data: 'uuid'},
                {data: 'uuid'},
            ],
            columnDefs: [
                {
                    targets: 0,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return Utils.translate(`export.exports.${full.name}`);
                    },
                },
                {
                    targets: 1,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return `${new Date(Date.parse(full.created_at)).toLocaleString()}`;
                    },
                },
                {
                    targets: 2,
                    render: (data: any, type: any, full: any, meta: any) => {
                        if (full.status === "DONE") {
                            return `${new Date(Date.parse(full.finished_at)).toLocaleString()}`;
                        } else {
                            return ""
                        }
                    },
                },
                {
                    targets: 3,
                    render: (data: any, type: any, full: any, meta: any) => {
                        let bar =`<div class="progress position-relative" style="height: 16px;">
    <div class="progress-bar bg-primary progress-bar-striped" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
    <small class="justify-content-center d-flex position-absolute w-100" style="color:#000000;">Nicht gestartet</small>
</div>`
                        if(full.progress === 100){
                            bar =`<div class="progress position-relative" style="height: 16px;">
    <div class="progress-bar bg-success progress-bar-striped" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    <small class="justify-content-center d-flex position-absolute w-100" style="color:#FFFFFF;">Abgeschlossen</small>
</div>`
                        } else if (full.progress !== 0) {
                            bar =`<div class="progress position-relative" style="height: 16px;">
    <div class="progress-bar bg-success progress-bar-striped" role="progressbar" style="width: ${full.progress}%" aria-valuenow="${full.progress}" aria-valuemin="0" aria-valuemax="100"></div>
    <small class="justify-content-center d-flex position-absolute w-100" style="color:#000000;">${full.progress}% abgeschlossen</small>
</div>`
                        }
                        return bar
                    },
                },
                {
                    targets: 4,
                    searchable: false,
                    orderable: false,
                    render: (data: any, type: any, full: any, meta: any) => {
                        if (full.status === "DONE") {
                            return `<div class="d-flex align-items-center justify-content-end">
                                  <a href="${full.url}" class=" btn btn-success">
                                    <i class="ti ti-download ti-sm"></i>
                                  </a>
                                </div>`
                        } else {
                            return ""
                        }
                    },
                }
            ],
            processing: true,
            dom:
                '<"row me-2 align-items-center"' +
                '<"col-md-2"<"me-3 m-3"l>>' +
                '<"col-md-10"<"dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-3 mb-md-0"fB>>' +
                '>t' +
                '<"row mx-2 align-items-center justify-content-between"' +
                '<"col-6"i>' +
                '<"col-2 mt-3"p>' +
                '>',

            language: {
                sLengthMenu: '_MENU_',
                search: '',
                searchPlaceholder: `${Utils.translate('generic.search')}...`,
                "zeroRecords":    `${Utils.translate('generic.datatable.no_results')}`,
                "emptyTable":     `${Utils.translate('generic.datatable.no_results')}`,
                "paginate": {
                    "first":      `${Utils.translate('generic.datatable.pagination.first')}`,
                    "last":       `${Utils.translate('generic.datatable.pagination.last')}`,
                    "next":       `${Utils.translate('generic.datatable.pagination.next')}`,
                    "previous":   `${Utils.translate('generic.datatable.pagination.previous')}`
                },
                "info":           `${Utils.translate('generic.datatable.info.info')}`,
                "infoEmpty":      `${Utils.translate('generic.datatable.info.empty')}`,
                "infoFiltered":   `${Utils.translate('generic.datatable.info.filtered')}`,
            },
            buttons: [
            ]
        });
    }
}